import { createRoot } from 'react-dom/client';

import { App } from './App';
import { initMonitoring } from './monitoring';

initMonitoring();

const container = document.getElementById('app');
const root = createRoot(container!);
root.render(<App />);
